import { FC } from "react";
import { KTSVG } from "../../_metronic/helpers";
import moment from "moment";
import { MyAttendance } from "../../interfaces/Attendance";
import { useIntl } from 'react-intl';

interface AttendanceAttachmentsProps {
    image: string
    attendance: MyAttendance;
    updateType: string;
}

const AttendanceAttachments: FC<AttendanceAttachmentsProps> = ({ image, attendance, updateType }) => {
    const intl = useIntl()
    
    return (
        <div className="modal fade" tabIndex={-1} id={`attachments-attendance-modal`}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{updateType == "clockIn" ? intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.CLOCK_IN_PHOTO" }) : intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.CLOCK_OUT_PHOTO" })} {attendance.userName}<br />{moment(updateType == "clockIn" ? attendance.dateClockIn : attendance.dateClockOut).format('dddd, DD MMMM YYYY HH:mm')}</h5>
                        <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <div className="modal-body text-center">
                        <img src={image} alt={image} className="img-fluid" />
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            data-bs-dismiss="modal"
                        >
                            {intl.formatMessage({ id: "FORM.ACTION.CLOSE" })}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { AttendanceAttachments }